import axios from 'axios';
import { put, takeLatest } from 'redux-saga/effects';

import {
  getAdminGuide,
  getClientInfoFetch,
  getClientInfoSuccess
} from '../reducers/ClientInfo';

import { BASE_URL } from '../../settings';
import { api_prefix } from '../../Constants/constants';
import { showError } from '../../CommonUtilities/CommonUtilities';

function* fetchClientInfo() {
  try {
    const updatedBASE_URL = BASE_URL.replace('admin-', '');
    const getClientInfoUrl = `${updatedBASE_URL}${api_prefix}publicview/get_client_info/`;

    const clientInfo = yield axios
      .get(getClientInfoUrl)
      .then((response) => response.data);

    yield put(getClientInfoSuccess({ clientInfo: clientInfo?.data }));
  } catch (err) {
    console.error(err);
  }
}

function* fetchAdminGuide() {
  try {
    const adminGuide = yield axios
      .get(`${BASE_URL}${api_prefix}guide/get_admin_guide/`)
      .then((response) => response.data);

    window.open(adminGuide?.data?.admin_guide, '_blank');
  } catch (error: any) {
    showError(error);
  }
}

export default function* watchClientInfo() {
  yield takeLatest(getClientInfoFetch, fetchClientInfo);
  yield takeLatest(getAdminGuide, fetchAdminGuide);
}
